module.exports = __webpack_public_path__ + "static/img/fapiao_yixuan.86ed0896.svg";